export default __webpack_public_path__ + "static/media/restore.fd4db8d9.pdf";